import { Auth } from '@aws-amplify/auth';
import {
  AuthApi,
  BalanceApi,
  BalanceSimulateApi,
  ConceptCreateApi,
  ConceptFileGetApi,
  ConceptGetApi,
  ConceptPlanFileApi,
  ContactApi,
  DesignPatternApi,
  LineMessagingApi,
  MAreaApi,
  MLineApi,
  MOptionApi,
  MOptionReferenceApi,
  MPrefectureApi,
  MStationApi,
  MTaxRateApi,
  PostNumberApi,
  FavoritePropertyApi,
  PasswordApi,
  PropertyApi,
  PropertyNoAuthApi,
  PropertySelectionInquiryApi,
  RegistrationApi,
  TodoApi,
  UserApi,
  MailLetterApi,
  Configuration,
  InteriorDesignOrderApi,
  InteriorDesignCompanyApi,
  DesignMatchingApi
} from 'openapi/omise-craft-core-spec';

export const initCoreApi = (baseUrl: string) => {
  // 要認証Config
  const openApiConfig = new Configuration({
    basePath: baseUrl,
    accessToken: () =>
      Auth.currentSession().then((session) => {
        return session.getAccessToken().getJwtToken();
      })
  });
  // 認証不要Config
  const noAuthOpenApiConfig = new Configuration({
    basePath: baseUrl
  });

  // 要認証
  authApi = new AuthApi(openApiConfig);
  balanceApi = new BalanceApi(openApiConfig);
  balanceSimulateApi = new BalanceSimulateApi(openApiConfig);
  conceptCreateApi = new ConceptCreateApi(openApiConfig);
  conceptFileGetApi = new ConceptFileGetApi(openApiConfig);
  conceptGetApi = new ConceptGetApi(openApiConfig);
  conceptPlanFileApi = new ConceptPlanFileApi(openApiConfig);
  designPatternApi = new DesignPatternApi(openApiConfig);
  favoritePropertyApi = new FavoritePropertyApi(openApiConfig);
  propertyApi = new PropertyApi(openApiConfig);
  todoApi = new TodoApi(openApiConfig);
  userApi = new UserApi(openApiConfig);
  mailLetterApi = new MailLetterApi(openApiConfig);
  propertySelectionInquiryApi = new PropertySelectionInquiryApi(openApiConfig);
  lineMessagingApi = new LineMessagingApi(openApiConfig);
  interiorDesignOrderApi = new InteriorDesignOrderApi(openApiConfig);
  interiorDesignCompanyApi = new InteriorDesignCompanyApi(openApiConfig);
  interiorDesignOrderApi = new InteriorDesignOrderApi(openApiConfig);
  designMatchingApi = new DesignMatchingApi(openApiConfig);

  // 認証不要
  mAreaApi = new MAreaApi(noAuthOpenApiConfig);
  mLineApi = new MLineApi(noAuthOpenApiConfig);
  mOptionApi = new MOptionApi(noAuthOpenApiConfig);
  mOptionReferenceApi = new MOptionReferenceApi(noAuthOpenApiConfig);
  mPrefectureApi = new MPrefectureApi(noAuthOpenApiConfig);
  mStationApi = new MStationApi(noAuthOpenApiConfig);
  mTaxRateApi = new MTaxRateApi(noAuthOpenApiConfig);
  postNumberApi = new PostNumberApi(noAuthOpenApiConfig);
  registrationApi = new RegistrationApi(noAuthOpenApiConfig);
  passwordApi = new PasswordApi(noAuthOpenApiConfig);
  noAuthPropertyApi = new PropertyNoAuthApi(noAuthOpenApiConfig);

  contactApi = new ContactApi(openApiConfig);
};

// 運用ログイン
export let authApi: AuthApi;

// 店舗コンセプト
export let conceptCreateApi: ConceptCreateApi;
export let conceptFileGetApi: ConceptFileGetApi;
export let conceptGetApi: ConceptGetApi;
export let conceptPlanFileApi: ConceptPlanFileApi;

// お気に入り物件
export let favoritePropertyApi: FavoritePropertyApi;

// メール配信設定
export let mailLetterApi: MailLetterApi;

// マスタ系
export let mAreaApi: MAreaApi;
export let mLineApi: MLineApi;
export let mOptionApi: MOptionApi;
export let mOptionReferenceApi: MOptionReferenceApi;
export let mPrefectureApi: MPrefectureApi;
export let mStationApi: MStationApi;
export let mTaxRateApi: MTaxRateApi;
export let postNumberApi: PostNumberApi;

// パスワード系
export let passwordApi: PasswordApi;

// 物件情報
export let propertyApi: PropertyApi; // 要認証（post用）
export let noAuthPropertyApi: PropertyNoAuthApi; // 認証不要（get用）

// 物件選定サポート
export let propertySelectionInquiryApi: PropertySelectionInquiryApi;

// 会員登録
export let registrationApi: RegistrationApi;

// ユーザ情報
export let userApi: UserApi;

// 簡易損益シミュレーション
export let balanceApi: BalanceApi;
export let balanceSimulateApi: BalanceSimulateApi;

// TODOリスト
export let todoApi: TodoApi;

// 内装会社マッチング
export let designPatternApi: DesignPatternApi;

// 問い合わせ
export let contactApi: ContactApi;

// LINE Messaging API
export let lineMessagingApi: LineMessagingApi;

//内装案件
export let interiorDesignOrderApi: InteriorDesignOrderApi;

// 内装会社管理
export let interiorDesignCompanyApi: InteriorDesignCompanyApi;

// 内装会社マッチング
export let designMatchingApi: DesignMatchingApi;
